export default {
  isLoading: false,
  isOpenModalEliminar: false,
  isOpenModalEditar: false,
  isOpenModalDesactivar: false,
  empresa: {},
  searchEmpresa: {},
  isNewEmpresa: null,
  listaEmpresas: [],
  listaEmpresasFiltradas: [],
  filtrosEmpresas: null,
  listaSegmentoSel: [
    {
      ID: 1,
      Description: "PYME",
    },
    {
      ID: 2,
      Description: "Gran Cliente",
    }
  ],
  base64file: null,
};
